import { render, staticRenderFns } from "./PortMenu.vue?vue&type=template&id=bc9e24b4&"
import script from "./PortMenu.vue?vue&type=script&lang=js&"
export * from "./PortMenu.vue?vue&type=script&lang=js&"
import style0 from "./PortMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports